import clsx from 'clsx';
import Video from '@/components/Video/Video';
import type {VideoModel} from '@/types/content';

type Props = {
    className?: string;
    video: VideoModel;
    containerClassName?: string;
    loop?: boolean;
};

const AemVideo = ({className, video, containerClassName, loop}: Props) => {
    const {path, thumbnailPath, startTime, endTime, isShowPlayPauseButton, showPlayPauseButtonAlt} = video;

    return (
        <Video
            ref={null}
            autoplay
            loop={loop}
            className={clsx('h-full w-full', className)}
            containerClassName={containerClassName}
            controlAriaLabel={showPlayPauseButtonAlt}
            isControlsVisible={isShowPlayPauseButton}
            muted
            playsinline
            thumbnailSrc={thumbnailPath}
            src={path}
            startTime={startTime ?? 0}
            stopTime={endTime ?? undefined}
        />
    );
};

export default AemVideo;
